module.exports = __webpack_public_path__ + "static/media/foto-contactos.8a3f8bcb.jpg";